'use strict';

angular.module('shiftTraderApp')
  .factory('Shifts', function (ServerUrls, $http, $q, Session) {

    //SHIFT MODEL OBJECT
    var Shift = function(initData) {
      var s = {};
      angular.extend(s, initData);
      s._type = 'shift';
      s.active = true;
      s._lengthInHours = Math.abs((s.end_minutes - s.start_minutes) / 60.0);
      if (s.start_minutes > s.end_minutes) {
        s._lengthInHours = (60 * 24 - s.start_minutes + s.end_minutes) / 60.0;
      }
      s._uniqueId = 's' + s.id;

      s.$modifyTimesWithTwix = function(theTwix) {
        s.start_time = moment(theTwix.start);
        s.end_time = moment(theTwix.end);
        s.range_twix = moment(s.start_time).twix(moment(s.end_time));
        s._lengthInHours = s.range_twix.length('minutes') / 60.0;
        s._startTimeUnix = s.start_time.unix();
        s._endTimeUnix = s.end_time.unix();
        s._timeDeltaFromShift = true;
        return s;
      };

      s.$setDateForTimeCalcs = function(dt) {
        var hour = Math.floor(s.start_minutes / 60.0);
        s.start_time = moment(dt).tz(Session.getTimezone()).hours(hour).minutes(s.start_minutes - hour * 60).seconds(0).milliseconds(0);
        s._startTimeUnix = s.start_time.unix();

        hour = Math.floor(s.end_minutes / 60.0);
        s.end_time = moment(dt).hours(hour).minutes(s.end_minutes - hour * 60).seconds(0).milliseconds(0);
        s._endTimeUnix = s.end_time.unix();
        // the case where the shift ends on the following day
        if (s.start_minutes > s.end_minutes) {
          s.end_time = s.end_time.add(1, 'days');
          s._endTimeUnix = s.end_time.unix();
          s._lengthInHours = (60 * 24 - s.start_minutes + s.end_minutes) / 60.0;
        }

        s.range_twix = s.start_time.twix(s.end_time);
        return s;
      };

      s.$update = function(newData) {
        var data = {id: this.id};
        angular.extend(data, newData);

        return $http.put(url + '/' + this.id, data )
          .then(function(response) {
            return new Shift(response.data);
          }, function(response) {
            return $q.reject(response);
          });
      };

      s.$isPublished = function() {
        return false;
      };

      s.$isAssigned = function() {
        return false;
      };

      s.$isWorkPeriod = function() {
        return false;
      };

      s.$isShift = function() {
        return true;
      };

      return s;
    };

    //SHIFTS CREATE/QUERY LAYER
    var url = ServerUrls.current.railsApi + 'shifts';
    var Shifts = {};

    Shifts.initWithData = function(initData) {
      return new Shift(initData);
    };

    Shifts.getAllInOrg = function(params) {
      var config = {
        params: {
          'organization_id': Session.getCurrentOrgId()
        }
      };

      if (angular.isDefined(params)) {
        angular.extend(config.params, params);
      }

      return $http.get(url, config)
        .then(function (response) {
          return _.map(response.data, function(shift) {
            return Shifts.initWithData(shift);
          });
        }, function(response) {
          return $q.reject(response);
        });
    };

    Shifts.create = function(data) {
      return $http.post(url, data)
        .then(function(response) {
          return response.data;
        }, function(response) {
          return $q.reject(response);
        });
    };

    return Shifts;
  });
